// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"languageSwither_languageSwitcher__SuCqw","languageOptions":"languageSwither_languageOptions__jaPjf","selectBox":"languageSwither_selectBox__d5jIo"};